import { render, staticRenderFns } from "./MenuRegiLink.vue?vue&type=template&id=cd81f324&scoped=true"
import script from "./MenuRegiLink.vue?vue&type=script&lang=js"
export * from "./MenuRegiLink.vue?vue&type=script&lang=js"
import style0 from "./MenuRegiLink.vue?vue&type=style&index=0&id=cd81f324&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd81f324",
  null
  
)

export default component.exports